import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { RootScopeService } from '../../core/services/root-scope.service';
import { StorageService } from '../../core/services/storage.service';
import { IApplicationMethodAccess } from 'src/app/models/interface/IAppMethodAccess';
import { PageCacheStrategy } from '../../core/services/page-cache.strategy';
// Make a shared entry point for all componsent services
@Injectable({
  providedIn: 'root'
})
export class ComponentServices {
  activeComponent: IApplicationMethodAccess | null = null;
  private readonly customerRouteMap: { [custId: string]: string } = {
    AutoEmail: '/email-template',
    WCMSA: '/sent-emails'
  };

  /* PLEASE AVOID PUT ANY OTHER LOGIC IN THIS CLASS. It's only a helper for all components to declare less stuff in their constructor.
      All requirements that involved usage of an object at global/casenotebook level should be handled by store.
  */
  constructor(public rootScope: RootScopeService,
                
              public storageService: StorageService,
              public http: HttpClient, public router: Router,
              private pageCache: PageCacheStrategy) { }

  public switchCustomerActiveComponent(custtId: string): Promise<boolean> {
    const activeComponent = this.activeComponent;

    if (activeComponent?.switchCustomer) {
      activeComponent.switchCustomer(custtId);
      return Promise.resolve(true);
    }

    return this.InitializeCustomerSwitchingProcess(custtId);
  }

  private getRouteForCustomer(custId: string): string {
    return this.customerRouteMap[custId] || '/entries';
  }

  public InitializeCustomerSwitchingProcess(custId: string) {
    const promise = new Promise<void>((resolve, reject) => {
      this.rootScope.globals.currentCustomer = custId;
      this.rootScope.globals.currentCustomerName =
        this.rootScope.globals.customers.filter(x => x.customer_cd === custId)[0].customer_name;
      this.rootScope.globals.menuItems =
        this.rootScope.globals.customers.filter(x => x.customer_cd === custId)[0].menu_items;
      this.rootScope.globals.source =
        this.rootScope.globals.customers.filter(x => x.customer_cd === custId)[0].meta_source;
      this.storageService.setSession('globals', this.rootScope.globals);
      // Pages kept for back/forward still show the previous customer's data.
      this.pageCache.clear();

      // swap literal '/entries' for mapped route
      const path = this.getRouteForCustomer(custId);
      this.router.navigate([path]);

      resolve();
    });

    return promise.then(
      () => Promise.resolve(true),
      (error) => Promise.reject(error)
    );
  }
}
